import { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext<(message: string) => void>(() => {});

export const useShellToast = () => useContext(ToastContext);

export function ShellToastProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState('');
  const [animKey, setAnimKey] = useState(0);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const showToast = useCallback((msg: string) => {
    clearTimeout(timerRef.current);
    setMessage(msg);
    setAnimKey((k) => k + 1);
    timerRef.current = setTimeout(() => setAnimKey(0), 1800);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {animKey > 0 && (
        <>
          <style>{`
            @keyframes hrToastFade {
              0% { opacity: 0; transform: translateY(6px); }
              12% { opacity: 1; transform: translateY(0); }
              55% { opacity: 1; }
              100% { opacity: 0; transform: translateY(-4px); }
            }
          `}</style>
          <div
            key={animKey}
            style={{
              position: 'absolute',
              top: 14,
              left: 14,
              right: 14,
              zIndex: 100,
              padding: '10px 12px',
              borderRadius: 8,
              background: 'rgba(11,6,24,0.95)',
              border: '1px solid #FBBF24',
              textAlign: 'center',
              animation: 'hrToastFade 1.8s ease forwards',
              pointerEvents: 'none',
            }}
          >
            <span className='text-sm font-semibold text-white'>{message}</span>
          </div>
        </>
      )}
    </ToastContext.Provider>
  );
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
